import SHPermission from './src/permission.vue';

/* istanbul ignore next */
SHPermission.install = function(Vue) {
  Vue.component('sh-permission', SHPermission);
};

export default SHPermission;



// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/role/permission/index.js